export const displayImage = (e: string) => {
  return `${process.env.REACT_APP_API_DOMAIN}/image/asset/${e}`;
};
